import React, { useState } from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import IconKey from "../../component/SvgIcons/IconKey";
import Logo from "../../component/SvgIcons/Logo";
import IconUser from "../../component/SvgIcons/IconUser";
import GlobalLogo from "../../component/SvgIcons/GlobalLogo";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";
import { useAuth } from "../../context/AuthContext"; 
import LogoGlobalAssist from "../../component/SvgIcons/LogoGlobalAssist";
import LogoMobile from "../../component/SvgIcons/LogoMobile";

export default function Login() {
  const {login} = useAuth(); // inside your login page/component
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [identifier, set_identifier] = useState("");
  const { alert } = useSwal();
  const navigate = useNavigate();

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   if (!identifier || !password) {
  //     return alert("warning", "Please enter both email and password.");
  //   }

  //   try {
  //     const response = await api.post("/login", { identifier, password });
  //     console.log("response", response.data);

  //     const { token, user } = response.data;

  //     // Store token in localStorage with expiration time (1 day)
  //     const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 1 day from now
  //     localStorage.setItem("authToken", token);
  //     localStorage.setItem("user", JSON.stringify(user));
  //     console.log("user", user);




  //     localStorage.setItem("tokenExpiry", expirationTime);

  //     if (response.status === 200) {
  //       // On successful login:
  //       setAuthUser({
  //         ...response.data,
  //         isAdmin: response.data.user.isAdmin === "Yes"

  //       });

  //       alert("success", "Login successful!");

  //       // Store token if backend sends it
  //       if (response.data.token) {
  //         localStorage.setItem("authToken", response.data.token);
  //       }

  //       // Navigate to dashboard
  //       navigate("/dashboard");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     alert("error", err.response?.data?.message || "Login failed.");
  //   }
  // };
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!identifier || !password) {
      return alert("warning", "Please enter both email and password.");
    }

    try {
      const response = await api.post("/loginToken", { identifier, password });
      if (response.status === 200) {
        alert("success", "Login successful!");

        if (response.data.user.token) {
          localStorage.setItem("authToken", response.data.user.token);
          login(response.data.user.token)
        }
        navigate("/dashboard");
      }
    } catch (err) {
      console.error(err);
      alert("error", err.response?.data?.message || "Login failed.");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!identifier) {
      return alert("warning", "Please enter your email.");
    }

    try {
      const response = await api.post("/forgot-password", { email: identifier });
      alert("success", response.data.message || "Reset link sent! Please check your email.");
      setIsForgotPassword(false);
    } catch (error) {
      alert("error", error.response?.data?.message || "Failed to send reset link.");
    }
  };

  return (
    <div className="login-main">
        <div className="advisor-logo">
          {/* <GlobalLogo /> */}
          <img src="../images/Gulf-logo.svg" alt="Gulf-logo" />
        </div>
      <form className="loginform" onSubmit={handleLogin}>      

        <div className="create-form d-flex flex-column">
          <div className="login-logo text-center">
            <div className="loginpage">
              <LogoMobile/>
              </div>
            <div className="LogoGlobalAssist">
            <LogoGlobalAssist/>
            </div>
          </div>

          {!isForgotPassword ? (
            // Login Form
            <>
              <h1 className="text-center">Log In to Your Account</h1>
              <div className="form-group">
                <label>E-Mail</label>
                <input
                  type="email"
                  name="email"
                  value={identifier}
                  onChange={(e) => set_identifier(e.target.value)}
                  className="form-control"
                  placeholder="Enter E-Mail"
                />
                <Link className="hereshowpassword tranparenteffect">
                  <IconUser />
                </Link>
              </div>

              <div className="form-group">
                <label>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="Password"
                  className="form-control"
                  placeholder="Enter Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Link
                  className="hereshowpassword tranparenteffect"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <IconKey />
                </Link>
              </div>
              {/* <Link to="/dashboard" className="btn btngradiant">
                Login
              </Link>  */}
              <button type="submit" className="btn btngradiant">
                Login
              </button>
              <Link
                to="#"
                className="forgotpassword text-center"
                onClick={() => setIsForgotPassword(true)}
              >
                Forgot Password?
              </Link>

            </>
          ) : (
            // Forgot Password Form
            <>
              <h1 className="text-center">Oops! Lost Your Password?</h1>
              <div className="form-group">
                <label>E-Mail</label>
                <input
                  type="email"
                  name="email"
                  value={identifier}
                  onChange={(e) => set_identifier(e.target.value)}
                  className="form-control"
                  placeholder="Enter your email"
                />
              </div>

              <button
                type="button"
                className="btn btngradiant"
                onClick={handleForgotPassword}
              >
                Send Reset Link
              </button>

              <Link
                to="#"
                className="forgotpassword text-center"
                onClick={() => setIsForgotPassword(false)}
              >
                Back to Login
              </Link>
            </>
          )}

        <Link to="https://globalsoftwares.net/" target="_blank" className="text-center copyright">©GlobalSoftware</Link>
        </div>
      </form>
    </div>
  );
}
